import src from "./douglas-elliman-logo-desktop.png";
export default { src: src, aspect: 7.2857, width: 816, height: 112 };